import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guid',
  templateUrl: './guid.component.html',
  styleUrls: ['./guid.component.css']
})
export class GuidComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
